export default "__VITE_ASSET__9e93976b__"